export default {
  AWS_ACCESS_KEY_ID: 'AWS_ACCESS_KEY_ID',
  AWS_SECRET_ACCESS_KEY: 'AWS_SECRET_ACCESS_KEY',
  DISTRIBUTION_ID: 'DISTRIBUTION_ID',
  MAKO_URL: 'MAKO_URL',
  CLOUDFRONT_URL: 'CLOUDFRONT_URL',
  RECAPTCHA_SITE_KEY: 'RECAPTCHA_SITE_KEY',
  SEGMENT_KEY: 'SEGMENT_KEY',
  LABS_URL: 'LABS_URL',
  ADS_PACKAGE_ID: 'ADS_PACKAGE_ID',
  MAKO_HOST_URL: 'MAKO_HOST_URL',
};



// WEBPACK FOOTER //
// ./src/constants/environment.js